<div *ngIf="matrix && rows.length && columns.length">
  <div class="body-b2 table-container" [class.modal-size]="conf.onlyOneResource">
    <table [class.bg-white]="conf.onlyOneResource">
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let column of columns" class="p-4">
            <div class="flex flex-col matrix-table__header">
              <div *ngIf="!conf.onlyOneResource" [class.th-border]="!column.displayName" class=" flex flex-col my-6 text-left">
                {{('objects.' + column.subtype) | translate}}
                <span *ngIf="column.displayName" class="th-border mt-2">{{column.displayName}}</span>
              </div>
              <div class="flex justify-start">
                <span *ngFor="let action of actions" class="mr-4">
                  <mat-icon [svgIcon]="iconsAvailable[view][action]" [matTooltip]="('matrix.tooltips.' + action) | translate"></mat-icon>
                </span>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <th class="flex flex-col">
            <span class="ml-2" [ngClass]="{'places': places.includes(row.subtype), 'documents': documents.includes(row.subtype) || row.subtype === RECORD_DETAILS}">
              {{('objects.' + row.subtype) | translate}}
            </span>
            <span *ngIf="row.displayName" [ngClass]="{'places': places.includes(row.subtype), 'documents': documents.includes(row.subtype) || row.subtype === RECORD_DETAILS}" class="ml-2">{{row.displayName}}</span>
          </th>
          <td *ngFor="let column of columns">
            <span *ngFor="let action of actions" class="checkbox">
              <input [id]="id+action+getIdOrSubType(column)+getIdOrSubType(row)" type="checkbox" class="checkbox__input" [checked]="!!matrix[getIdOrSubType(column)][getIdOrSubType(row)]?.includes(action)" (change)="changeValue(getIdOrSubType(row), getIdOrSubType(column), action,  $event)" [disabled]="action===PERMACTION.read && row.id && row.id === column.id">
              <label [for]="id+action+getIdOrSubType(column)+getIdOrSubType(row)" class="checkbox__label" [ngClass]="{disabled: action===PERMACTION.read && row.id && row.id === column.id}"></label>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-end items-center mt-4 mb-6">
    <a (click)="restoreMatrix()" class="mr-4 flex justify-center items-center">
      <mat-icon svgIcon="redo" color="primary" [ngClass]="{'text-disabled' : !conf.canSave}" class="block mr-2"></mat-icon>
      <p [ngClass]="{'text-disabled' : !conf.canSave}" class="link block m-0">{{'buttons.restore' | translate}}</p>
    </a>
    <app-button-secondary [disabled]="!conf.canSave" (click)="saveMatrix()" class="mr-6">{{'buttons.save' | translate}}</app-button-secondary>
  </div>
</div>

<div *ngIf="!rows.length || !columns.length" class="h-96 flex flex-col items-center justify-center">
  <img src="../../assets/img/icon-usyncro_green-200.png" alt="{{'matrix.noPermissions' | translate}}" class="opacity-30 mt-12">
  <span *ngIf="view !== 'documents'" class="mt-12">{{'matrix.noPermissions' | translate}}</span>
  <span *ngIf="view === 'documents'" class="mt-12">{{'matrix.noDocuments' | translate}}</span>
  <span *ngIf="view !== 'documents'">{{'matrix.addElements' | translate}}</span>
</div>
